import React, { useState } from 'react';
import Modal from './Modal';
import Button from './Button';

export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
}) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleConfirm = async () => {
    setSubmitting(true);
    setError(null);
    try {
      await onConfirm();
      onClose?.();
    } catch (err) {
      setError(err?.message || 'Something went wrong.');
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={submitting ? undefined : onClose}
      title={title}
      maxWidth={420}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={submitting}>
            {cancelLabel}
          </Button>
          <Button variant={variant} onClick={handleConfirm} loading={submitting}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <p style={{ margin: 0, color: 'var(--text-secondary)', fontSize: 'var(--text-body-size)', lineHeight: 1.5 }}>
        {message}
      </p>
      {error && (
        <div role="alert" style={{ marginTop: 'var(--space-3)', color: 'var(--danger)', fontSize: 13 }}>
          {error}
        </div>
      )}
    </Modal>
  );
}
